import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { CheckboxNew } from 'src/editor/shared/ui-lib/checkbox-new'

class DeviceAppearance extends PureComponent {
  toggleDesktop = () => {
    const { entity } = this.props
    const {
      options: { appearance = {} },
    } = entity
    const nextValue = !appearance.desktop
    const updatedEntity = {
      ...entity,
      options: {
        ...entity.options,
        appearance: {
          ...appearance,
          desktop: nextValue,
          mobile: (!appearance.mobile && !nextValue) || appearance.mobile,
        },
      },
    }

    this.props.update(updatedEntity)
  }

  toggleMobile = () => {
    const { entity } = this.props
    const {
      options: { appearance = {} },
    } = entity
    const nextValue = !appearance.mobile
    const updatedEntity = {
      ...entity,
      options: {
        ...entity.options,
        appearance: {
          ...appearance,
          desktop: (!appearance.desktop && !nextValue) || appearance.desktop,
          mobile: nextValue,
        },
      },
    }

    this.props.update(updatedEntity)
  }

  render() {
    const { entity } = this.props
    const {
      options: { appearance = {} },
    } = entity
    const { mobile = true, desktop = true } = appearance

    return (
      <React.Fragment>
        <GroupTitle>settings_options.device_appearance.label</GroupTitle>
        <CheckboxNew
          wrapperClassName='mt-4'
          label='settings_options.device_appearance.desktop'
          onChange={this.toggleDesktop}
          checked={desktop}
        />
        <CheckboxNew
          wrapperClassName='mt-3'
          label='settings_options.device_appearance.mobile'
          onChange={this.toggleMobile}
          checked={mobile}
        />
      </React.Fragment>
    )
  }
}

DeviceAppearance.propTypes = {
  update: PropTypes.func.isRequired,
  entity: PropTypes.objectOf(PropTypes.any).isRequired,
}

export default DeviceAppearance
